// Sections above an anchor target grow after the first paint (fonts, images,
// widgets), so a single scroll lands short or past the heading. For a few
// seconds after landing, re-align the target whenever the page has stopped
// scrolling but the target is not where its CSS scroll-margin-top says it
// should be. Any user input (wheel, touch, keys, mouse) cancels it.

const SETTLE_MS = 4000;
const POLL_MS = 200;
const INPUT_EVENTS = ['wheel', 'touchstart', 'keydown', 'mousedown'];

let cancelPrevious = null;

const keepAnchorInView = (id, { immediate = true } = {}) => {
  if (typeof window === 'undefined' || !id) return;
  if (cancelPrevious) cancelPrevious();

  let lastY = null;
  const started = Date.now();

  const align = () => {
    const el = document.getElementById(id);
    if (!el) return;
    const margin = parseFloat(window.getComputedStyle(el).scrollMarginTop) || 0;
    if (Math.abs(el.getBoundingClientRect().top - margin) > 1) {
      el.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    // react-stickynode misses a scroll position set before it mounted (the navbar
    // then scrolls away with the page); a resize makes it measure again
    if (window.scrollY > 0 && !document.querySelector('.sticky-nav-active')) {
      window.dispatchEvent(new Event('resize'));
    }
  };

  const stop = () => {
    window.clearInterval(timer);
    INPUT_EVENTS.forEach((name) => window.removeEventListener(name, stop));
    if (cancelPrevious === stop) cancelPrevious = null;
  };

  const timer = window.setInterval(() => {
    if (Date.now() - started > SETTLE_MS) {
      stop();
      return;
    }
    const idle = window.scrollY === lastY;
    lastY = window.scrollY;
    if (idle) align();
  }, POLL_MS);

  INPUT_EVENTS.forEach((name) => window.addEventListener(name, stop, { passive: true }));
  cancelPrevious = stop;
  if (immediate) align();
};

module.exports = { keepAnchorInView };
